<template>
  <div>
    <v-form @submit.prevent v-model="valid">
      <b class="d-block mb-1"> Modelo de envio </b>
      <v-btn-toggle
        :value="data.type"
        @change="setKey('type', $event)"
        color="primary"
        class="w-full"
        mandatory
      >
        <v-btn
          v-for="item in modalTypes"
          :key="item.id"
          :value="item.id"
          class="flex-1"
          small
          :disabled="readonly"
        >
          {{ item.name }}
        </v-btn>
      </v-btn-toggle>

      <v-card
        v-if="data.type.includes('other')"
        class="pa-2 mt-4"
        rounded="lg"
        outlined
      >
        <b class="mb-2">Envio Particular</b>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.company"
              @input="setKey('company', $event)"
              label="Empresa de Envio"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Empresa de Envio é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.freight_category"
              @input="setKey('freight_category', $event)"
              label="Categoria do Envio"
              outlined
              dense
              hide-details
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.freight_price"
              @input="setKey('freight_price', $event, parseFloat)"
              label="Preço do Envio"
              prefix="R$"
              type="number"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Preço do Envio é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Prazo de Entrega"
              type="number"
              :value="data.freight_days"
              @input="setKey('freight_days', $event, parseFloat)"
              outlined
              dense
              hide-details
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.freight_tracking_number"
              @input="setKey('freight_tracking_number', $event)"
              label="Número de Rastreio"
              outlined
              dense
              hide-details
              :disabled="readonly"
            />
          </v-col>
        </v-row>
      </v-card>
      <v-card
        v-if="data.type.includes('correios')"
        class="pa-2 mt-4"
        rounded="lg"
        outlined
      >
        <b class="mb-2">Envio Correios</b>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              :value="data.freight_category"
              @input="setKey('freight_category', $event)"
              label="Categoria do Envio"
              outlined
              dense
              hide-details
              :item-value="(item) => item.id"
              :item-text="(item) => item.name"
              :items="correiosTypes"
              :disabled="readonly"
              :rules="[(v) => !!v || 'Categoria do Envio é obrigatório']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.freight_price"
              @input="setKey('freight_price', $event, parseFloat)"
              label="Preço do Envio"
              prefix="R$"
              type="number"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Preço do Envio é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Prazo de Entrega"
              type="number"
              :value="data.freight_days"
              @input="setKey('freight_days', $event, parseFloat)"
              outlined
              dense
              hide-details
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.freight_tracking_number"
              @input="setKey('freight_tracking_number', $event)"
              label="Número de Rastreio"
              outlined
              dense
              hide-details
              :disabled="readonly"
            />
          </v-col>
        </v-row>
      </v-card>

      <v-text-field
        :value="data.other_price"
        @input="setKey('other_price', $event, parseFloat)"
        label="Outros custos"
        hint="Apenas relacionados ao envio"
        prefix="R$"
        class="mt-4"
        outlined
        dense
        :disabled="readonly"
      />
      <v-textarea
        v-if="data.other_price && data.other_price > 0"
        :value="data.other_description"
        @input="setKey('other_description', $event)"
        label="Descrição dos outros custos"
        hide-details
        rows="2"
        outlined
        dense
        :rules="[(v) => !!v || 'Descrição dos outros custos é obrigatório']"
        :disabled="readonly"
      />
    </v-form>
  </div>
</template>

<script>
const defaultData = () => {
  return {
    type: "correios",
    // freight
    company: null,
    freight_category: null,
    freight_price: null,
    freight_tracking_number: null,
    freight_days: null,

    // other
    other_price: null,
    other_description: null,
  };
};

export const manifest = {
  id: "FREIGHT",
  name: "Envio",
  icon: "mdi-truck",
  description: "Envio de equipamentos",
  defaultData: defaultData,
};

export default {
  name: "FreightEditor",
  props: {
    value: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      modalTypes: [
        { id: "correios", name: "Correios" },
        { id: "other", name: "Particular" },
      ],
      correiosTypes: [
        { id: "pac", name: "PAC" },
        { id: "sedex", name: "Sedex" },
        { id: "sedex_10", name: "Sedex 10" },
        { id: "sedex_hoje", name: "Sedex Hoje" },
      ],
    };
  },
  methods: {
    setKey(key, value, parse = false) {
      this.data = {
        ...this.data,
        [key]: !value ? value : parse ? parse(value) : value,
      };
    },
    getTotal() {
      let value = 0;
      value += this.data.freight_price || 0;
      value += this.data.other_price || 0;

      return value;
    },
  },
  watch: {
    valid(value) {
      this.$emit("update:valid", value);
    },
    "data.type": {
      handler(value, oldValue) {
        if (value !== oldValue) this.data.freight_category = null;
      },
      deep: true,
    },
    data: {
      handler(value) {
        this.$emit("update:amount", this.getTotal());
      },
      deep: true,
    },
  },
  computed: {
    data: {
      get() {
        return this.value || defaultData();
      },
      set(value) {
        this.$emit("update", value);
      },
    },
  },
  mounted() {
    this.$emit("update:valid", this.valid);
  },
};
</script>
